import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import createStore from "APP_ROOT/createStore";
import { combineReducers } from "redux";
import { ID } from "APP_ROOT/constants";
import { composables } from "@orange-marmalade/paginate-this";

export const incomingQuoteLineItemsPagination = createPaginatedList({
  listId: "incomingQuotes/lineItems",
  stateLocator: state => state.incomingQuotes.lineItems,
  initialSettings: {
    pageSize: 15
  },
  fetch: search => {
    const id = createStore()
      .getState()
      .incomingQuoteDetail.getIn(["incomingQuote", ID]);
    return api.incomingQuotes.lineItems.search(id, search);
  }
});

export const expireLineItems = composables({
  listId: "incomingQuotes/lineItems"
}).expire;

export const incomingQuotePagination = createPaginatedList({
  listId: "incomingQuotes",
  fetch: api.incomingQuotes.search,
  stateLocator: state => state.incomingQuotes.main,
  forceDebounce: true
});

export default combineReducers({
  main: incomingQuotePagination.paginator,
  lineItems: incomingQuoteLineItemsPagination.paginator
});



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/pagination.js